const API = process.env.REACT_APP_BACKEND_URL;

// fetch with a timeout so the UI can never hang forever on a slow AI call.
const withTimeout = (ms) => {
  const c = new AbortController();
  const id = setTimeout(() => c.abort(), ms);
  return { signal: c.signal, done: () => clearTimeout(id) };
};

const post = async (path, body, ms = 30000) => {
  const t = withTimeout(ms);
  try {
    const res = await fetch(`${API}/api/ai${path}`, {
      method: "POST", headers: { "Content-Type": "application/json" },
      credentials: "include", body: JSON.stringify(body), signal: t.signal,
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(json.detail || "AI request failed");
    return json;
  } catch (e) {
    if (e.name === "AbortError") throw new Error("AI is taking too long — please try again");
    throw e;
  } finally { t.done(); }
};

export const aiBrief = (context) => post("/brief", { context }).then((r) => r.summary);
export const aiSuggestTasks = (text) => post("/suggest-tasks", { text }).then((r) => r.tasks || []);

export const aiTranscribe = async (blob) => {
  const t = withTimeout(60000);
  try {
    const fd = new FormData();
    fd.append("file", blob, "note.webm");
    const res = await fetch(`${API}/api/ai/transcribe`, { method: "POST", credentials: "include", body: fd, signal: t.signal });
    const json = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(json.detail || "Transcription failed");
    return json.text || "";
  } catch (e) {
    if (e.name === "AbortError") throw new Error("Transcription timed out — please try again");
    throw e;
  } finally { t.done(); }
};
